"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointMessageOut = void 0;
class EndpointMessageOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointMessageOut.attributeTypeMap;
    }
}
exports.EndpointMessageOut = EndpointMessageOut;
EndpointMessageOut.discriminator = undefined;
EndpointMessageOut.attributeTypeMap = [
    {
        "name": "channels",
        "baseName": "channels",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "eventId",
        "baseName": "eventId",
        "type": "string",
        "format": ""
    },
    {
        "name": "eventType",
        "baseName": "eventType",
        "type": "string",
        "format": ""
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "string",
        "format": ""
    },
    {
        "name": "nextAttempt",
        "baseName": "nextAttempt",
        "type": "Date",
        "format": "date-time"
    },
    {
        "name": "payload",
        "baseName": "payload",
        "type": "any",
        "format": ""
    },
    {
        "name": "status",
        "baseName": "status",
        "type": "MessageStatus",
        "format": ""
    },
    {
        "name": "tags",
        "baseName": "tags",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "timestamp",
        "baseName": "timestamp",
        "type": "Date",
        "format": "date-time"
    }
];
//# sourceMappingURL=EndpointMessageOut.js.map